import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FAQ_ITEMS } from '../data/mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { Badge } from '../components/ui/badge';
import * as Icons from 'lucide-react';

const fadeInUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-60px' },
  transition: { duration: 0.5, ease: 'easeOut' },
};

export default function FAQPage() {
  return (
    <main>
      <section className="pt-32 pb-16 px-6" style={{ background: 'radial-gradient(at 53% 78%, hsla(60,100%,50%,0.12) 0px, transparent 50%), radial-gradient(at 71% 91%, hsla(108,100%,50%,0.12) 0px, transparent 50%)' }}>
        <div className="max-w-[800px] mx-auto text-center">
          <motion.div {...fadeInUp}>
            <Badge className="mb-5 bg-[rgba(148,242,127,0.12)] text-[rgb(13,121,22)] border-[rgba(148,242,127,0.3)] px-4 py-1.5 text-xs font-medium rounded-full">Help Center</Badge>
          </motion.div>
          <motion.h1 {...fadeInUp} transition={{ delay: 0.1 }}
            className="font-bold text-[rgb(0,55,32)] tracking-tight mb-4"
            style={{ fontSize: 'clamp(2rem, 4.5vw, 3.5rem)', lineHeight: '0.92' }}>
            Frequently Asked Questions
          </motion.h1>
          <motion.p {...fadeInUp} transition={{ delay: 0.2 }}
            className="text-[rgb(131,146,140)] max-w-[550px] mx-auto" style={{ fontSize: 'clamp(1rem, 2vw, 1.15rem)' }}>
            Answers to common questions about our process, pricing, and services.
          </motion.p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="max-w-[750px] mx-auto px-6">
          <motion.div {...fadeInUp}>
            <Accordion type="single" collapsible className="w-full">
              {FAQ_ITEMS.map((item, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-black/10">
                  <AccordionTrigger className="py-5 text-left text-sm font-medium text-[rgb(0,55,32)] hover:no-underline">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-[rgb(131,146,140)] leading-relaxed pb-5">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16" style={{ background: 'rgba(0,0,0,0.02)' }}>
        <div className="max-w-[600px] mx-auto px-6 text-center">
          <motion.div {...fadeInUp}>
            <h2 className="font-semibold text-[rgb(0,55,32)] text-xl mb-3">Still Have Questions?</h2>
            <p className="text-sm text-[rgb(131,146,140)] mb-6">We're happy to help. Book a free consultation or give us a call.</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/book" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-br from-[#8FEC78] to-[#81DD67] text-white font-semibold text-sm no-underline hover:shadow-md transition-shadow">
                Book Free Consult <Icons.ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-black/10 text-[rgb(0,55,32)] font-medium text-sm no-underline hover:bg-black/5 transition-colors">
                Contact Us
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </main>
  );
}
